export default "__VITE_ASSET__BOvdl3YB__"